import {
    extFromMineType,
    formatSize,
    isAudioFileElement,
    isFileElement,
    isFileVideoElement, isNoteElement, isObject,
    isPdfFileElement, isString,
    recursionMindmapData
} from "@/utils";
import {getCardDoc} from "@model/card";
import {ipcInvoke} from "@/common/ipc";
import {isImageElement, isMindmapElement} from "../@excalidraw/packages/excalidraw/element/typeChecks";
import {KEY_FILE_DIR} from "@/Const";
import {getNoteDoc} from "@model/note";
import {loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import { t } from "i18next";

/**
 * 统计project的大小
 * @param project
 */
export async function staticProject(project:any,szBoardId:any){
    //canvas 的大小 + 附件...
    let nSize = 0;
    if (!project.doc){
        const doc = await getNoteDoc(project.id);
        if (doc){
            project.doc = doc?.doc;
        }
    }
    if (!project.doc){
        return {
            cards:0,
            pdfs:0,
            videos:0,
            audios:0,
            files:0,
            formatSize:'0MB',
            size:0
        }
    }
    if (isObject(project.doc)){
        nSize += JSON.stringify(project.doc).length;
    }else{
        nSize += project.doc.length;
    }


    //计算library
    let jsonDoc;
    if (isString(project.doc)){
        jsonDoc = JSON.parse(project.doc);
    }else{
        jsonDoc = (project.doc);
    }
    for (let i=0;i<jsonDoc.notes.length;i++){
        const note = jsonDoc.notes[i];
        const szHtml:any = await getCardDoc(note.key)?.catch(e=>{

        });
        nSize += szHtml.length;
    }
    let nCards = 0, nPdfs = 0,nVideos = 0,nAudios = 0,nFiles = 0;
    const szDir = localStorage.getItem(KEY_FILE_DIR);
    //元素中的文件.
    await loopAllNodeAsync(jsonDoc.canvas,async (canvas:any)=>{
        if (canvas.drawJson?.elements && (!szBoardId || (szBoardId && canvas.key == szBoardId))){
            for (let j=0;j<canvas.drawJson.elements.length;j++){
                const element = canvas.drawJson.elements[j];
                if (isFileElement(element) && element.customData.generationData.fileName){
                    const nFileSize = await ipcInvoke('get-file-size',{filePath:szDir+element.customData.generationData.fileName});
                    nSize += nFileSize;
                    if (isPdfFileElement(element)){
                        nPdfs ++;
                    }else if (isFileVideoElement(element)){
                        nVideos ++;
                    }else if (isAudioFileElement(element)){
                        nAudios ++;
                    }else{
                        nFiles ++;
                    }
                }else if (isNoteElement(element)){
                    nCards ++;
                }
                else if (isMindmapElement(element)){
                    await recursionMindmapData(element.data,(async (data:any)=>{
                        if (data.extra){
                            if (data.extra.type == 'pdf' && data.extra.fileName){
                                const nFileSize = await ipcInvoke('get-file-size',{filePath:szDir + data.extra.fileName});
                                nSize += nFileSize;

                                nPdfs++;
                            }else if (data.extra.type == 'card'){
                                //取card
                                const szHtml = await getCardDoc(data.extra.id);
                                if (szHtml){
                                    nSize += szHtml.length;
                                }

                                nCards ++;
                            }
                        }
                    }))
                }else if (isImageElement(element)){
                    //图片，算上..
                    const fileInfo = canvas.drawJson.files[element.fileId];
                    if (fileInfo){
                        const szFilePath = szDir + fileInfo.id + '.' + extFromMineType(fileInfo.mimeType);
                        const nFileSize = await ipcInvoke('get-file-size',{filePath:szFilePath});
                        nSize += nFileSize;
                    }
                }
            }
        }
    })
    // for (let i=0;i<jsonDoc.canvas.length;i++){
    //     const canvas = jsonDoc.canvas[i];
    //
    // }
    let szSizeDesc = formatSize(nSize);

    return {
        cards:nCards,
        pdfs:nPdfs,
        videos:nVideos,
        audios:nAudios,
        files:nFiles,
        formatSize:szSizeDesc,
        size:nSize
    }
}


/**
 * 根据类型获取操作符
 * @param szType
 */
export function getFilterOperator(szType){
    let menu;
    if (szType == 'name' || szType == 'text' ||
        szType == 'url' || szType == 'notes' || szType == 'link' ||
        szType == 'select' || szType == 'multiSelect'){
        menu = [
            {
                label:t('Is'),
                value:'is'
            },
            {
                label:t('Is not'),
                value:'isNot'
            },
            {
                label:t('Contains'),
                value:'contains'
            },
            {
                label:t('DoesNotContain'),
                value:'doesNotContain'
            },
            {
                label:t('Is empty'),
                value:'isEmpty'
            },
            {
                label:t('Is not empty'),
                value:'isNotEmpty'
            }
        ]
    }else if (szType == 'date' || szType == 'createTime' || szType == 'updateTime'){
        menu = [
            {
                label:t('Equals'),
                value:'equals'
            },
            {
                label:t('Before'),
                value:'before'
            },
            {
                label:t('After'),
                value:'after'
            },
            {
                label:t('Is empty'),
                value:'isEmpty'
            },
            {
                label:t('Is not empty'),
                value:'isNotEmpty'
            }
        ]
    }else if (szType == 'checkbox'){
        menu = [
            {
                label:t('Is'),
                value:'is'
            },
        ]
    }else if (szType == 'number' || szType == 'rating'){
        menu = [
            {
                label:'=',
                value:'='
            },
            {
                label:'≠',
                value:'≠'
            },
            {
                label:'>',
                value:'>'
            },
            {
                label:'≥',
                value:'≥'
            },
            {
                label:'<',
                value:'<'
            },
            {
                label:'≤',
                value:'≤'
            },
            {
                label:t('Is empty'),
                value:'isEmpty'
            },
            {
                label:t('Is not empty'),
                value:'isNotEmpty'
            }
        ]
    }else if (szType == 'tags' || szType == 'type'){
        menu = [
            {
                label:t('Is'),
                value:'is'
            },
            {
                label:t('Is not'),
                value:'isNot'
            },
            {
                label:t('Contains'),
                value:'contains'
            },
            {
                label:t('DoesNotContain'),
                value:'doesNotContain'
            },
        ]
    }
    return menu;
}

/**
 * 获取三级的值
 * @param szType
 */
export const getFilterOptionValue = (szType)=>{
    let menu:any = [];
    if (szType == 'checkbox'){
        menu = [
            {
                label:t('Checked'),
                value:'checked'
            },
            {
                label:t('Unchecked'),
                value:'unchecked'
            }
        ]
    }
    return menu;
}